import React, { FC, useEffect, useRef } from 'react';
import { Form, Input, InputRef } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Catcher } from '../../Catcher';
import ViewStyles from '../../styles/m_viewStyles.less';

type IForm2FACodeConfirm = {
    isLoading: boolean;
    onOneTimePasswordChange: (e: any) => void;
    onSubmit: (e: any) => void;
};

export const Form2FACodeConfirm: FC<IForm2FACodeConfirm> = ({
    isLoading,
    onOneTimePasswordChange,
    onSubmit,
}: IForm2FACodeConfirm) => {
    const input2FARef = useRef<InputRef>(null);

    useEffect(() => {
        if (input2FARef) {
            input2FARef.current!.focus({
                cursor: 'all',
            });
        }
    }, [input2FARef]);

    return (
        <Catcher>
            <div className={ViewStyles.body}>
                <div className={ViewStyles.text}>
                    <p>Please, enter your one time code to proceed:</p>
                </div>
                <Form layout="vertical">
                    <Form.Item>
                        <Input
                            disabled={isLoading}
                            onChange={onOneTimePasswordChange}
                            onPressEnter={onSubmit}
                            placeholder={'Code'}
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            ref={input2FARef}
                        />
                    </Form.Item>
                </Form>
            </div>
        </Catcher>
    );
};
